import api from "@/lib/api";

export function postSupportMessage(path, text, file) {
  if (!file) return api.post(path, { text });
  const body = new FormData();
  body.append("image", file);
  body.append("text", text);
  return api.post(path + "/image", body);
}
